export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5356.6b18d53b.jpg";